import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home'
import Service from '../views/service'
import Inter from '../views/inter'
import Medical from '../views/medical'
import ProductCenter from '../views/productCenter'
import Operaing from '../views/operaing'
import SupandSer from '../views/SupandSer'
import AboutUs from '../views/aboutUs'
import Recruiment from '../views/recruiment'

// import ProductCenter from '@/views/ProductCenter'
// import Service from '@/product/service'
// import aa from '@/views/Home/aa.vue'
// import Layout from '@/Layout'
// import footer from '@/layout/footer'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          component: Home
        }
      ]

    },
    // {
    //   path: '/product',
    //   component: Product,
    //   children: [
    //     {
    //       path: '/product',
    //       component: Product
    //     }
    //   ]

    // },
    {
      path:'/service',
      name:'service',
      component: Service,
    },
    {
      path:'/inter',
      name:'inter',
      component: Inter,
    },
    {
      path:'/medical',
      name:'Medical',
      component: Medical,
    },
    {
      path:'/operaing',
      name:'Operaing',
      component: Operaing,
    },
    {
      path:'/productCenter',
      name:'ProductCenter',
      component: ProductCenter,
    },
    {
      path:'/SupandSer',
      name:'SupandSer',
      component: SupandSer,
    },
    {
      path:'/recruiment',
      name:'recruiment',
      component: Recruiment,
    },
    {
      path:'/aboutUs',
      name:'aboutUs',
      component: AboutUs,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js